import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function CTABand({ title, subtitle, primaryLabel, primaryTo, secondaryLabel, secondaryTo }) {
  return (
    <section className="section-dark" data-testid="cta-band">
      <div className="max-w-[1280px] mx-auto px-5 md:px-10 lg:px-14 py-20 md:py-28 grid md:grid-cols-12 gap-8 items-end">
        <div className="md:col-span-8">
          <h2 className="display-lg text-white">{title}</h2>
          {subtitle && <p className="mt-4 text-white/70 text-lg max-w-2xl leading-relaxed">{subtitle}</p>}
        </div>
        <div className="md:col-span-4 flex flex-col sm:flex-row md:flex-col gap-3 md:justify-end">
          {primaryTo && (
            <Link to={primaryTo} className="btn-primary bg-white text-[color:var(--primary-dark)] border-white hover:bg-[color:var(--accent-amber)] hover:border-[color:var(--accent-amber)]" data-testid="cta-band-primary-btn">
              {primaryLabel} <ArrowRight size={18} />
            </Link>
          )}
          {secondaryTo && (
            <Link to={secondaryTo} className="btn-secondary border-white text-white hover:bg-white hover:text-[color:var(--primary-dark)]" data-testid="cta-band-secondary-btn">
              {secondaryLabel}
            </Link>
          )}
        </div>
      </div>
    </section>
  );
}
